shadow$provide[199] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Data:{enumerable:true, get:function() {
  return Data;
}}});
var UData = require("../../../util/data.js");
var require$_DOT__DOT__SLASH_base_SLASH_source_DOT_js = require("../base/source.js");
class Data extends require$_DOT__DOT__SLASH_base_SLASH_source_DOT_js.Source {
  static initClass() {
    this.traits = ["node", "data", "source", "index", "entity", "active"];
  }
  init() {
    this.dataEmitter = null;
    return this.dataSizes = null;
  }
  emitter(channels, items) {
    let emitter, resolve;
    const {data, bind, expr} = this.props;
    if (data != null) {
      const last = this.dataSizes;
      const sizes = UData.getSizes(data);
      if (!last || last.length !== sizes.length) {
        const thunk = UData.getThunk(data);
        this.dataEmitter = this.callback(UData.makeEmitter(thunk, items, channels));
        this.dataSizes = sizes;
      }
      emitter = this.dataEmitter;
    } else if (resolve != null) {
      resolve = this._inherit("resolve");
      emitter = this.callback(resolve.callback(bind));
    } else if (expr != null) {
      emitter = this.callback(expr);
    } else {
      emitter = this.callback(this.passthrough);
    }
    return emitter;
  }
  callback(callback) {
    return callback != null ? callback : function() {
    };
  }
  update() {
  }
  make() {
    this._helpers.active.make();
    this.first = true;
    return this._listen("root", "root.update", () => {
      if (this.isActive || this.first) {
        this.update();
      }
      return this.first = false;
    });
  }
  unmake() {
    this._helpers.active.unmake();
    this.dataEmitter = null;
    return this.dataSizes = null;
  }
}
Data.initClass();

};